import { MeasureIcon } from '@principle-theorem/principle-core/interfaces';
import { BigQueryTable } from '@principle-theorem/reporting/interfaces';
import { QueryOptionResolver } from '../../query-option-resolvers';
import {
  BaseDimensionMeasures,
  BaseDimensionTableJoin,
} from '../base-measures';
import { MeasurePath } from '../data-accessor-factory';
import { CanBeChartedProperty, CanDoAllProperty } from '../measure-properties';
import { MeasurePropertyFactory } from '../measure-property-factory';

export class StafferDimensionMeasures extends BaseDimensionMeasures {
  name: CanDoAllProperty;

  constructor(
    table: BigQueryTable,
    id: string,
    tableJoin?: BaseDimensionTableJoin
  ) {
    super(table, id, tableJoin);
    this.name = this._getNameProperty();
  }

  get ref(): CanBeChartedProperty {
    const docRef = this.measureRef(MeasurePath.docRef('ref'));
    return MeasurePropertyFactory.docRef(
      {
        id: this._pathWithPrefix('ref'),
        label: 'Practitioner Ref',
        optionResolver: QueryOptionResolver.staff(),
        availableAsColumn: false,
        availableAsChart: false,
      },
      docRef,
      this.buildQuery().attributes([docRef.attributePath]).get()
    );
  }

  private _getNameProperty(): CanDoAllProperty {
    const name = this.measureRef('user.name');
    const docRef = this.measureRef(MeasurePath.docRef('ref'));
    return MeasurePropertyFactory.docRef(
      {
        id: this._pathWithPrefix('name'),
        label: 'Practitioner Name',
        summary: '',
        optionResolver: QueryOptionResolver.staff(),
        icon: MeasureIcon.Person,
        isPii: true,
        piiType: 'name',
      },
      docRef,
      this.buildQuery()
        .attributes([name.attributePath, docRef.attributePath])
        .get(),
      name
    );
  }
}
